import {undoPendingBuilding, undoRepairBuilding} from '../../../redux/actions';
import {CONSTRUCTION_ACTION_TYPES} from '../../../constants/construction';

// Экшен, отменяющий действие строительства из pendingBuildings: ремонт и
// постройка откатываются разными редьюсерами
export const createUndoConstructionAction = (building) => (
  building.type === CONSTRUCTION_ACTION_TYPES.BUILDING_REPAIRMENT
    ? undoRepairBuilding(building.hexKey, building.damage)
    : undoPendingBuilding(building.hexKey, building.token, building.price, building.previousToken)
);
